import type { RequestParameters } from 'maplibre-gl';
import config from 'src/config';
import authStorageService from 'src/shared/hooks/services/auth-storage-service';

/** Signs the tile requests MapLibre makes, and only those.
 *
 *  The tile endpoint is guarded, and MapLibre fetches tiles itself, so the header
 *  has to be added here. The host check is what keeps the bearer token off every
 *  other request the map makes — the basemap provider must never see it.
 */
export const siteTileRequestTransform =
    (engineApiUrl: string, accessToken: () => string | null) =>
    (url: string): RequestParameters | undefined => {
        const isEngineUrl = new URL(url).origin === new URL(engineApiUrl).origin;
        if (!isEngineUrl) return undefined;

        const token = accessToken();
        if (!token) return undefined;

        return { url, headers: { authorization: token } };
    };

/** What every map that reads engine tiles passes to `MapCanvas`.
 *
 *  The token is read on each request rather than captured: `transformRequest` cannot
 *  await, so an expired one stops the tiles until the next render.
 */
export const signEngineTileRequests = siteTileRequestTransform(config.engineApiUrl, () => authStorageService.getAccessToken());
